import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SubmitConferenceForm from '../components/SubmitConferenceForm';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle } from 'lucide-react';

const SubmitConference = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';
  const canceled = searchParams.get('canceled') === 'true';

  useEffect(() => {
    if (success) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: 'conf_' + Date.now(),
          value: 49.00,
          currency: 'USD',
          items: [{
            item_name: 'Conference Submission',
            item_category: 'Listing Fee',
            price: 49.00,
            quantity: 1,
          }],
        },
      });
    }
  }, [success]);

  if (success) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <Header />
        <div className="container mx-auto px-4 py-24 text-center max-w-xl">
          <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Payment Successful!</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            Your conference has been submitted and is now under review. We'll notify you by email once it's approved and live on the site.
          </p>
          <Link to="/"><Button className="bg-purple-600 hover:bg-purple-700 text-white px-8 h-12 text-lg">Back to Home</Button></Link>
        </div>
        <Footer />
      </div>
    );
  }

  if (canceled) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <Header />
        <div className="container mx-auto px-4 py-24 text-center max-w-xl">
          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Payment Canceled</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
            Your payment was not completed. You can try again below.
          </p>
          <Link to="/submit"><Button className="bg-purple-600 hover:bg-purple-700 text-white px-8 h-12 text-lg">Try Again</Button></Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
              Submit Your Conference
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              Share your SEO event with our community. All submissions are
              reviewed within 24-48 hours.
            </p>
          </div>
          <SubmitConferenceForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SubmitConference;
